"use client";

import { Award, Handshake, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroduccionParaTiendas() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: pillarsRef,
    isVisible: pillarsVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const pillars = [{
    icon: Award,
    title: "Calidad Premium",
    description: "Aceite de oliva virgen extra elaborado con los más altos estándares de calidad y cuidado artesanal."
  }, {
    icon: Handshake,
    title: "Historia Familiar",
    description: "Tradición y autenticidad transmitidas de generación en generación, reflejadas en cada botella."
  }, {
    icon: Truck,
    title: "Distribución Directa",
    description: "Suministro confiable y directo desde nuestro olivar hasta su establecimiento gourmet."
  }];
  return <section id="introducción-para-tiendas" className="relative bg-background overflow-hidden section">
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/premium_gourmet_partnership_hero.png)] bg-cover bg-center" />
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative container">
        <div ref={heroRef} className={`max-w-3xl mx-auto text-center mb-24 transition-all duration-800 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-serif text-4xl font-semibold mb-8 leading-tight !text-[hsl(48,100%,96%)] md:text-6xl">
            Socio de Confianza para el Canal Gourmet
          </h1>
          <p className="font-sans text-lg text-secondary/90 mb-10 leading-relaxed">
            Ofrecemos a tiendas delicatessen y distribuidores un aceite de
            oliva virgen extra de calidad excepcional, respaldado por nuestra
            tradición familiar y compromiso con la excelencia.
          </p>
          <Link to="#contacto">
            <Button className="btn">
              Solicitar Información
            </Button>
          </Link>
        </div>

        <div ref={pillarsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-800 delay-300 ${pillarsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <Card key={i} data-index={i} className="bg-white/90 border-none shadow-none p-10 lg:p-12 transition-all duration-300 rounded-lg">
                <CardContent className="p-0 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6">
                    <Icon className="size-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-serif text-2xl font-medium text-foreground mb-4">
                    {pillar.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed font-sans text-lg">
                    {pillar.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}